import "whatwg-fetch";
import "array.prototype.findindex";
import "array-flat-polyfill";
import React, { Component } from "react";
import ReactTooltip from "react-tooltip";
import { ConfigurationModes } from "./hcs-constants";
import HcsNavBarItem from "./hcs-navbar-item";
import HcsNavBarItemWelcome from "./hcs-navbar-item-welcome";
import HcsGroup from "./hcs-group";
import HcSInlineError from "./hcs-inlineerror";
import HcsVersionInfo from "./hcs-version-info";
import HcsPointAndClickHelper from "../controls/hcs-point-and-click-helper";
import MessageBox from "../messagebox";
import HcsSubconfigHistory from "./hcs-subconfig-histoy";
import { TrackingTypes } from "../tools/tracking-base";


export default class HcsConfigurator extends Component {
    constructor(props) {
        super(props);

        this.state = {
            error: null,
            cfgState: null,                             /* original ECS JSON configuration state */
            configurationData: null,                    /* ECS configuration state translated by groups */
            configurationDataTopLevel: null,            /* Configuration state of top level. This is being used to show complete navbar when in subconfiguration
                                                           because subconfigurations don't have all groups for nav data. */
            currentGroup: null,                         /* Current group ident */
            configVisible: true,                        /* Visibility state of configuration area */
            progressState: false,
            isSubConfig: false,                         /* "true" when currently in subconfiguration */
            subConfigMode: ConfigurationModes.Default,  /* Mode for handling of subconfigurations */
            subConfigName: null,                        /* Name/ident of current subconfiguration */
            subConfigDescription: null                  /* Description of current subconfiguration */
        };

        this.subConfigHistory = new HcsSubconfigHistory();

        this.requireUiUpdate = true;

        this.configure = this.configure.bind(this);
        this.changeGroup = this.changeGroup.bind(this);
        this.configWait = this.configWait.bind(this);
        this.checkValueChange = this.checkValueChange.bind(this);

        this.ratingTimer = null;

        this.ecsRequestListeners = [];

        this.navBarIconMapping = props.hcs.settings.get("SETTINGS.NAVBAR_ICON_MAPPING", "json") || {};
    }

    componentDidUpdate() {
        const { hcs } = this.props;
        const { error } = this.state;

        if(error) {
            if(error.messageType) {
                hcs.api.showError({
                    title: "Error in HCS renderer",
                    messageMap: error.messageType,
                    message: error
                });
            } else {
                hcs.api.showError({
                    title: "Error in HCS renderer",
                    message: error
                });
            }
            return;
        }
        
        if(this.requireUiUpdate) {
            hcs.ui.containerResized();
            this.requireUiUpdate = false;
        }
        
        hcs.onRenderFinished.call(this, {});

        let focusElementControl = this.props.hcs.container.querySelector(".hcs-it-focused");
        let focusElement = this.props.hcs.container.querySelector(".hcs-focused");

        if(focusElementControl) {
            if(focusElement) {
                focusElement.focus();
            }

            if(hcs.settings.get("SETTINGS.CONFIGURATION_AUTO_SCROLL_FOCUS", "bool")) {
                switch(true) {
                    case focusElementControl.classList.contains("hcs-button-next"):
                    case focusElementControl.classList.contains("hcs-navi"):
                        break;

                    default:
                        // Update scrollbar position after changing group
                        hcs.ui.configScrollbarUpdate(focusElementControl);
                        break;
                }
            } else {
                //hcs.ui.configScrollbarUpdate();
            }
        }

        ReactTooltip.rebuild();
        hcs.ui.navScrollbarUpdate();

        this.props.hcs.api.progressBar.progress(this.state.progressState);
    }

    onEcsRequest(listener) {
        this.ecsRequestListeners.push(listener);
    }

    reset() {
        this.subConfigHistory = new HcsSubconfigHistory();

        this.setState({
            error: null,
            cfgState: null,
            configurationData: null,
            currentGroup: null,
            configVisible: true,
            progressState: false
        });
    }

    /**
     * Some kind of group preprocessor.
     * Shall be called before this group is being activated.
     * Can be used to change the default behavior.
     * @param {string} groupId - ID of group to be pre-processed
     * @param {string} [sender] - Name/ID of the sender which has triggered the changeGroup() function.
     * @retuns {bool} Return "true" when default group handling shall be
     * performed. When doing custom handling you can return "false"
     * and stop all further group handling (like rendering, ...).
     */
    groupPreProcess(groupId, sender) {
        let self = this;
        
        const { configurationData } = this.state;

        let thisGroup = configurationData.items.find(item => item.groupId === groupId);
        let wizardControl = thisGroup ? thisGroup.attributes.find(a => a.info.type === "objlist" && a.data.CFG_CONTROL === "WIZARD") : undefined;

        switch(true) {
            // When our configuration contains a "wizard" item we automatically enter this wizard
            // by entering this object as subconfiguration.
            case typeof wizardControl !== "undefined":
                let wizardCfgObjName = wizardControl.ident;
                let wizardVisited = (wizardControl.cfgobjs[0] || { info: { visited: false } }).info.visited;

                const lastFinishedGroupId = (self.configurationData.lastFinished || { groupId: null }).groupId

                // Before entering the wizard we first check if the wizard previously has been already finished.
                // In this case we switch to the latest active group instead.
                // When the user wants to explicitely enter the wizard (because he clicks inside the navbar),
                // this is the case when "sender==HcsNavBarItem" we open the wizard anyway.
                if(sender !== "HcsNavBarItem" && lastFinishedGroupId && lastFinishedGroupId !== groupId) {
                    this.changeGroup(lastFinishedGroupId, sender);

                    self.setState({ currentGroup: lastFinishedGroupId }, _ => {
                        self.configure("setCurrentGroup");
                    });
                    return false;
                }

                // When group automatically changes to "Wizard" group immediately start wizard
                // when state is not "visited".
                // When user direktly clicks the "Wizard" group we have to start the wizard as well.
                if(!wizardVisited || sender === "HcsNavBarItem") {
                    this.subConfigHistory.changeGroup(groupId);

                    // Reset current group to set new group from subconfig.
                    this.setState({
                        currentGroup: null
                    }, _ => {
                        self.configure("enterSubCfgObject", null, null, {
                            subConfigMode: ConfigurationModes.Wizard,
                            subConfigName: wizardCfgObjName,
                            subConfigIndex: 0
                        });
                    });

                    return false;
                } else {
                    this.changeGroup("GOTO-NEXT");
                }
                break;
        }

        return true;
    }

    /**
     * Change configuration group.
     * @param {string} newGroup - Name of the group to be active.
     * There are some special functions which can be called using one of the following strings:
     * GOTO-NEXT - Go to next group
     * GOTO-PREV - Go to previous group
     * FIRST - Go to very first group
     * TOGGLE_VISIBILITY - Toggle visibility of configuration area.
     * @param {string} [sender] - Name/ID of the sender which triggers the changeGroup() function.
     * @param {object} [options] - Additional options
     * @param {bool} [options.usePreProcessor=true] - Allow to disable preprocessor handling.
     * In this case groupPreProcess() will not be called.
     */
    changeGroup(newGroup, sender, options) {
        let self = this;
        const { hcs } = this.props;
        const { currentGroup, configurationData } = this.state;

        options = Object.assign({}, {
            usePreProcessor: true
        }, options);

        // Toggle configuration panel visibility when user clicks on the nav button
        if(newGroup === "TOGGLE_VISIBILITY") {
            this.setState({
                configVisible: !this.state.configVisible
            });

            this.requireUiUpdate = true;
            return;
        }

        if(newGroup !== this.state.currentGroup) {
            this.setState({
                configVisible: true
            });

            if(options.usePreProcessor && (!["GOTO-NEXT", "GOTO-PREV"].includes(newGroup) && !this.groupPreProcess(newGroup, sender))) {
                return;
            }
        }

        let indexer = 0;

        if(this.ratingTimer) {
            clearTimeout(this.ratingTimer);
        }

        switch(newGroup) {
            case "GOTO-NEXT":
                indexer = 1;
                break;

            case "GOTO-PREV":
                indexer = -1;
                break;
        }

        switch(true) {
            // find new group to open
            case indexer === 1 || indexer === -1:
                configurationData.items.forEach((item, index) => {
                    let newIndex = index + indexer;

                    if(item.groupId === currentGroup) {
                        if(newIndex < 0 || newIndex > (configurationData.items.length - 1)) {
                            let errorMessage = "Change configuration group to '" + newGroup + "' failed, index out of range: " + newIndex;

                            console.error(errorMessage);

                            self.setState({
                                error: {
                                    message: errorMessage
                                }
                            });

                            newGroup = null;
                            return false;
                        }

                        newGroup = configurationData.items[newIndex].groupId;
                    }
                });
                break;

            case newGroup === "FIRST":
                newGroup = configurationData.items[0].groupId;
                break;
        }

        this.setState({ currentGroup: newGroup }, _ => {
            let focusElementControl = hcs.container.querySelector(".hcs-it-focused");

            if(focusElementControl) {
                focusElementControl.focus();

                if(hcs.settings.get("SETTINGS.CONFIGURATION_AUTO_SCROLL_FOCUS", "bool")) {
                    switch(true) {
                        case focusElementControl.classList.contains("hcs-button-next"):
                        case focusElementControl.classList.contains("hcs-navi"):
                            break;

                        default:
                            // Update scrollbar position after changing group
                            hcs.ui.configScrollbarUpdate(focusElementControl);
                            break;
                    }
                } else {
                    hcs.ui.configScrollbarUpdate();
                }
            }

            self.subConfigHistory.changeGroup(newGroup);

            self.configure("setCurrentGroup");
            hcs.cfgEngine.groupChanged(newGroup, self.state.configVisible);
            hcs.tracker.track(TrackingTypes.Progress, {
                previousStep: currentGroup,
                currentStep: newGroup,
                subConfigMode: self.state.subConfigMode ? self.state.subConfigMode.domAttr : null,
                subConfigName: self.state.subConfigName
            });

            let ng = configurationData.items.find(i => i.groupId === newGroup);

            if(self.state.subConfigMode === ConfigurationModes.Default) {
                let isLastGroupInMain = configurationData.items.indexOf(ng) === (configurationData.items.length - 1);

                if(isLastGroupInMain && hcs.settings.get("SETTINGS.RATING_ENABLED", "bool")) {
                    let dialogDelay = (hcs.settings.get("SETTINGS.RATING_DELAY_SECONDS", "int") || 0) * 1000;

                    self.ratingTimer = setTimeout(_ => {
                        hcs.api.startRating();
                    }, dialogDelay);
                }
            }

            // When group contains any Drag&Drop control we show the so called "Point and Click" helper tooltip.
            let hasDragAndDropControl = ng.attributes.find(a => a.info.visible && a.info.type === "select" && a.data.CONTROL_TYPE === "DRAG_DROP") ? true : false;

            this.setState({
                showPointAndClick: hasDragAndDropControl
            }, _ => {
                if(hasDragAndDropControl) {
                    self.pointAndClickHelper.show();
                }
            });
        });
    }

    /**
     * Reload session view in debug window.
     */
    updateDebugSession() {
        if(this.props.hcs.constants.showDebugWindow) {
            fetch(this.props.hcs.api.ecs({
                method: "DebugSessionObject"
            }))
                .then(res => res.json())
                .then(
                    (result) => {
                        window.cadclick.debug.showSession(result);
                    });
        }
    }

    /**
     * Wait until current(running) ECS callback has finished.
     * @param {string|Array} [method] - Single ECS methode name or array of method names. If not specified wait for all ECS methods.
     * @param {Object} [scope] - Object scope being transferred to the "resolve" event. Mostly being used to transfer the outer "this" scope.
     * @returns {Promise} Called when ECS callback has finished.
     */
    configWait(method, scope) {
        let self = this;

        if(typeof (method) === "string") {
            method = [method];
        }

        return new Promise((resolve) => {
            (async () => {
                var wait = function() {
                    if(self.callbackRunning && (typeof (method) === "undefined" || method === null || method.includes(self.callbackRunning)) ) {
                        setTimeout(wait, 100);
                    } else {
                        resolve.call(scope);
                    }
                };

                setTimeout(wait, 50);
            })();
        });
    }

    configure(method, attrName, attrValue, options) {
        const { currentGroup } = this.state;
        const { hcs } = this.props;
        let self = this;

        // Encode possible special characters to not mess-up URL query parameter
        if(attrValue) {
            attrValue = encodeURIComponent(attrValue);
        }

        // Save current callback running state for "configWait" function
        self.callbackRunning = method;

        let opts = Object.assign({}, {
            sender: null,
            attrChecked: "",
            quantity: 0,
            subConfigMode: null,
            subConfigName: null,
            subConfigDescription: null,
            subConfigIndex: -1,
            accept: null,
            jsonData: null,
            fromLocalStorage: false,
            updateStorageState: true,
            customScript: {
                functionName: null,
                arguments: null
            },
            getVariationAttributesList: {
                priceQuery: false,
                productDataAttributes: []
            },
            success: _ => { }
        }, options);

        let debugObj = Object.assign({}, {
            attrName: attrName,
            attrValue: attrValue,
            sender: opts.sender,
            attrChecked: opts.attrChecked !== "" ? opts.attrChecked : null,
            quantity: opts.quantity,
            subConfigMode: opts.subConfigMode,
            subConfigName: opts.subConfigName,
            subConfigIndex: opts.subConfigIndex > -1 ? opts.subConfigIndex : null,
            accept: opts.accept,
            fromLocalStorage: opts.fromLocalStorage,
            updateStorageState: opts.updateStorageState
        });

        // Convert all options to those which are of interest
        // and remove all "null" values.
        Object.keys(debugObj).forEach(key => {
            if(!debugObj[key]) {
                delete debugObj[key];
            }
        });

        window.cadclick.debug.console.debug("Configure: " + method + " - " + hcs.configurationId, debugObj);

        this.setState({
            error: null,

            /* Before entering wizard we hide old config UI */
            configUiHidden: opts.subConfigMode === ConfigurationModes.Wizard ? true : false
        });

        let ecsParams = { "currentGroup": currentGroup };
        let submitBuildInstructions = false;
        let postData = {};
        let lockUi = false;
        let loading = false;
        let updatePrice = false;
        let optionalTriggerData = null;

        switch(method) {
            case "startConfiguration":
                updatePrice = true;

                this.subConfigHistory.add(method, hcs.configurator, ConfigurationModes.Default);

                ecsParams = Object.assign({}, ecsParams, {
                    "configurationId": hcs.configurationId
                });

                postData = opts.jsonData;
                break;

            case "loadConfiguration":
                updatePrice = true;

                this.subConfigHistory.add(method, hcs.configurator, ConfigurationModes.Default);

                postData = {
                    "fromLocalStorage": opts.fromLocalStorage
                };
                break;

            case "resetConfiguration":
                ecsParams = Object.assign({}, ecsParams, {
                    "attrName": attrName
                });
                break;

            case "setCfgValue":
                submitBuildInstructions = true;
                updatePrice = true;

                ecsParams = Object.assign({}, ecsParams, {
                    "attrName": attrName,
                    "attrValue": attrValue,
                    "attrChecked": opts.attrChecked,
                    "subConfigName": this.state.subConfigName,
                    "sender": opts.sender
                });

                hcs.tracker.track(TrackingTypes.Config, { [ attrName ]: attrValue });
                break;

            case "setCfgValueQuantity":
                submitBuildInstructions = true;
                updatePrice = true;

                ecsParams = Object.assign({}, ecsParams, {
                    "attrName": attrName,
                    "attrValue": attrValue,
                    "quantity": opts.quantity,
                    "sender": opts.sender
                });
                break;

            case "setSubCfgValue":
                submitBuildInstructions = true;
                updatePrice = true;

                ecsParams = Object.assign({}, ecsParams, {
                    "attrName": attrName,
                    "attrValue": attrValue,
                    "subConfigName": opts.subConfigName,
                    "subConfigIndex": opts.subConfigIndex,
                    "attrChecked": opts.attrChecked,
                    "sender": opts.sender
                });

                hcs.tracker.track(TrackingTypes.Config, { [ attrName ]: attrValue });
                break;

            case "AddSubCfg":
            case "DeleteSubCfg":
                ecsParams = Object.assign({}, ecsParams, {
                    "subConfigName": opts.subConfigName
                });
                break;

            case "copySubCfgObject":
            case "deleteSubCfgObject":
                ecsParams = Object.assign({}, ecsParams, {
                    "subConfigName": opts.subConfigName,
                    "subConfigIndex": opts.subConfigIndex
                });
                break;

            case "customScriptFunction":
                postData = {
                    "customScriptFunctionName": opts.customScript.functionName,
                    "customScriptArguments": opts.customScript.arguments ? JSON.stringify(opts.customScript.arguments) : null
                };
                break;

            case "handleInstance":
                submitBuildInstructions = true;

                if(!opts.jsonData) {
                    console.warn("Cannot execute 'handleInstance' because there is no JSON data to be processed!");
                    return;
                }
                postData = {
                    instances: opts.jsonData.map(i => { return { dragItemInstanceData: i }; })
                };
                break;

            case "GetVariationAttributesList":
                postData = {
                    priceQuery: opts.getVariationAttributesList.priceQuery,
                    productDataAttributes: opts.getVariationAttributesList.productDataAttributes
                };
                break;

            case "addSubCfgObject":
                ecsParams = Object.assign({}, ecsParams, {
                    "subConfigName": opts.subConfigName
                });
                break;

            case "enterSubCfgObject":
                ecsParams = Object.assign({}, ecsParams, {
                    "subConfigName": opts.subConfigName,
                    "subConfigIndex": opts.subConfigIndex
                });
                break;

            case "exitCurrentCfgObject":
                ecsParams = Object.assign({}, ecsParams, {
                    "accept": opts.accept,
                    "subConfigName": this.state.subConfigName
                });
                break;
        }

        switch(method) {
            case "setCurrentGroup":
                break;

            case "handleInstance":
            case "customScriptFunction":
                lockUi = false;
                break;

            default:
                lockUi = true;

                if(hcs.constants.showDebugWindow) {
                    window.cadclick.debug.showEcs("");
                    window.cadclick.debug.showEcsResolved("");
                }
                break;
        }

        if(submitBuildInstructions) {
            postData.buildInstructions = hcs.cad.getBuildInstructions();
            postData.buildInstructionsAr = hcs.cad.getBuildInstructions({ format: "absolute" });
        }

        if(lockUi) {
            loading = true;

            setTimeout(() => {
                if(loading) {
                    self.setState({
                        progressState: "indeterminate"
                    });
                }

                if(self.state.configUiHidden) {
                    hcs.api.progressBar.progress("indeterminate");
                }
            }, 200);
        }

        let ecsUrl = hcs.api.ecs({
            method: method,
            params: ecsParams
        });

        fetch(ecsUrl, {
            method: "POST",
            body: hcs.api.ajaxCompressBody(postData, true),
            headers: {
                "Content-Type": "application/json;charset=UTF-8"
            }
        })
            .then(response => {
                return response.text();
            })
            .then(responseBodyAsText => {
                try {
                    const bodyAsJson = JSON.parse(responseBodyAsText);
                    return bodyAsJson;
                } catch(e) {
                    return {
                        success: false,
                        error: responseBodyAsText,
                        url: ecsUrl,
                        type: "unparsable"
                    };
                }
            })
            .then((result) => {
                loading = false;
                hcs.api.progressBar.progress(false);

                if(result.success === false && result.error) {
                    let error = result.type === "unparsable" ? result.error : Object.assign({}, result.error, { url: ecsUrl });

                    console.error(error);

                    self.setState({
                        error: error,
                        progressState: false,
                    });
                    return;
                }

                let ecsObject = {};

                if(result.ecs && result.ecs !== "") {
                    ecsObject = hcs.api.jsonParse(result.ecs, { errorMessage: "Error parsing ECS JSON result: " });
                }

                let callDefault = false;

                self.setState({
                    configUiHidden: false
                });

                switch(method) {
                    case "setCurrentGroup":
                        // We only call back the currently selected group.
                        // This won't change anything inside the configuration, thus
                        // there is not need to re-render UI.

                        self.updateDebugSession();
                        break;

                    case "handleInstance":
                        // Don't re-render UI.
                        opts.success.call(self, result);
                        self.updateDebugSession();

                        if(submitBuildInstructions) {
                            hcs.api.configStorage({
                                configured: true,
                                ccAOData: hcs.api.getBuildInstructions()
                            });
                        }
                        break;

                    case "customScriptFunction":
                    case "GetVariationAttributesList":
                        self.setState({
                            progressState: false
                        });

                        if(result.success === true) {
                            opts.success.call(self, result);
                        } else {
                            self.setState({
                                cfgState: null,
                                error: Object.assign({}, {
                                    messageType: null
                                }, result.error)
                            });
                        }
                        break;

                    case "enterSubCfgObject":
                    case "addSubCfgObject":
                        if(result.success === true) {
                            self.subConfigHistory.add(method, opts.subConfigName, opts.subConfigMode);

                            opts.success.call(self, result);

                            let topLevelCfgData = null;

                            switch(opts.subConfigMode) {
                                case ConfigurationModes.SubConfigurationTopMenu:
                                    topLevelCfgData = self.state.configurationData;
                                    break;
                            }

                            self.setState({
                                isSubConfig: true,
                                subConfigMode: opts.subConfigMode,
                                subConfigName: opts.subConfigName,
                                subConfigDescription: opts.subConfigDescription,
                                configurationDataTopLevel: topLevelCfgData
                            });

                            callDefault = true;
                        }
                        break;

                    case "exitCurrentCfgObject":
                        if(result.success === true) {
                            opts.success.call(self, result);

                            callDefault = true;
                        }
                        break;

                    default:
                        callDefault = true;
                        break;
                }

                if(callDefault) {
                    if(hcs.constants.showDebugWindow) {
                        window.cadclick.debug.showEcs(ecsObject);
                    }

                    if(result.success === true) {
                        // Depending on response object from ECS ('setCfgValue' or 'executeScriptFunction')
                        // 'errorinfo' and 'cfgState' are located under a different tree level inside the JSON object.
                        let cfgState = null;
                        let errorInfo = {};

                        switch(true) {
                            case ecsObject.cfgState ? true : false:
                                cfgState = ecsObject.cfgState;
                                break;

                            case ecsObject.result.cfgState ? true : false:
                                cfgState = ecsObject.result.cfgState;
                                break;

                            case ecsObject.result ? true : false:
                                cfgState = ecsObject.result;
                                break;

                            default:
                                throw new Error(`Could not evaluate configuration state from responding JSON object. Operation was: '${method}'`);
                        }

                        switch(true) {
                            case ecsObject.errorinfo ? true : false:
                                errorInfo = ecsObject.errorinfo;
                                break;

                            default:
                                errorInfo = ecsObject;
                                break;
                        }

                        if(cfgState) {
                            const configData = self.buildConfigurationData(cfgState);

                            let currentGroup = self.state.currentGroup;

                            switch(method) {
                                case "loadConfiguration":
                                case "resetConfiguration": {
                                    currentGroup = result.currentGroup;

                                    // Reset "last active" state.
                                    // In case of configuration reset we must set this state to the group
                                    // where we made the reset.
                                    let lastActivGroups = configData.items.filter(i => i.lastActive);
                                    let currentActiveGroup = configData.items.find(i => i.groupId === currentGroup);

                                    if(lastActivGroups) {
                                        lastActivGroups.forEach(i => {
                                            i.lastActive = false;
                                        });
                                    }

                                    if(currentActiveGroup) {
                                        currentActiveGroup.lastActive = true;
                                    }

                                    let ccaoData = opts.fromLocalStorage ? hcs.api.configStorage().ccAOData : null;

                                    

                                    if(!ccaoData) {
                                        try {
                                            ccaoData = JSON.parse(result.ccaoData || result.ccAOData);
                                        } catch(e) {
                                            ccaoData = { instances: [] };
                                        }
                                    }

                                    // Write initial configuration and all item placements to tracker.
                                    if(ccaoData.instances) {
                                        var loadCfgData = {};

                                        var loadDragItemIds = ccaoData.instances
                                            .filter(inst =>
                                                typeof (inst.instance.custom.dragItemData) !== "undefined" &&
                                                typeof (inst.instance.custom.dragItemData.ruleEngine) !== "undefined" &&
                                                typeof (inst.instance.custom.dragItemData.ruleEngine.exec) !== "undefined" &&
                                                typeof (inst.instance.custom.dragItemData.ruleEngine.exec.set) !== "undefined" &&
                                                inst.instance.custom.dragItemData.ruleEngine.exec.event === "SET_CFG_VALUE"
                                            ).map(inst => inst.instance.custom.dragItemData.ruleEngine.exec.set[0].value);

                                        configData.items.forEach((item, index) => {
                                            item.attributes.filter(attr => typeof (attr.info.value) !== "undefined" && attr.info.value !== "").forEach((attr, index) => {
                                                loadCfgData[attr.ident] = attr.info.value;
                                            });
                                        });

                                        hcs.tracker.track(TrackingTypes.LoadConfiguration, { configurationId: hcs.configurationId });
                                        hcs.tracker.track(TrackingTypes.Config, loadCfgData);

                                        (loadDragItemIds || []).forEach(itemId =>
                                            hcs.tracker.track(TrackingTypes.Placement, { "itemId": itemId })
                                        );
                                    }

                                    optionalTriggerData = {
                                        ccaoData: ccaoData
                                    };
                                }
                                    break;

                                case "enterSubCfgObject":
                                case "addSubCfgObject":
                                    currentGroup = null;
                                    break;
                            }

                            if(hcs.constants.showDebugWindow) {
                                window.cadclick.debug.showEcsResolved(configData);
                            }

                            // First load, cfg area is currently hidden and will now change to "visible"
                            // This requires recalculation of scene container.
                            this.requireUiUpdate = !this.state.cfgState;

                            self.setState({
                                cfgState: cfgState,
                                configurationData: configData,
                                progressState: false,
                                error: !errorInfo.bSuccess ? {
                                    message: errorInfo.errmsg,
                                    url: ecsUrl,
                                } : null
                            }, _ => {
                                if(currentGroup === null) {
                                    self.changeGroup((configData.items.find(i => i.isStartItem) || configData.items[0]).groupId);
                                }

                                switch(method) {
                                    case "loadConfiguration":
                                    case "resetConfiguration":
                                        if(currentGroup !== null) {
                                            self.changeGroup(currentGroup);
                                        }
                                        break;

                                    case "exitCurrentCfgObject":
                                        let currentSubConfig = self.subConfigHistory.pop();

                                        self.setState({
                                            isSubConfig: false,
                                            subConfigMode: self.subConfigHistory.last.subConfigMode,
                                            subConfigName: self.subConfigHistory.last.subConfigName,
                                            subConfigDescription: null,
                                            configurationDataTopLevel: null
                                        }, _ => {
                                            // When exiting "wizard" mode we automatically must change to next group in main config.
                                            if(currentSubConfig.subConfigMode === ConfigurationModes.Wizard) {
                                                let wizardIndex = -1;

                                                configData.items.forEach((group, groupIndex) => {
                                                    if(group.groupId === self.subConfigHistory.last.selectedGroup) {
                                                        wizardIndex = groupIndex;
                                                    }
                                                });

                                                if(wizardIndex > -1) {
                                                    self.changeGroup(configData.items[wizardIndex + 1].groupId);
                                                }
                                            } else {
                                                if(self.subConfigHistory.last && self.subConfigHistory.last.selectedGroup) {
                                                    self.changeGroup(self.subConfigHistory.last.selectedGroup);
                                                }
                                            }
                                        });
                                        break;
                                }
                            });

                            self.updateDebugSession();

                            opts.success.call(self, result);

                            if(ecsObject.triggerEvent) {
                                optionalTriggerData = {
                                    ccaoData: ecsObject.triggerEvent
                                };
                            }

                            if(submitBuildInstructions) {
                                if(opts.updateStorageState) {
                                    hcs.api.configStorage({
                                        configured: true,
                                        ccAOData: hcs.api.getBuildInstructions()
                                    });
                                }
                            }

                            if(updatePrice) {
                                hcs.cart.updatePrice();
                            }

                            self.ecsRequestListeners.forEach(listener => {
                                listener.call(self, {
                                    method: method,
                                    configurationData: configData
                                });
                            });
                        } else {
                            console.error("ECS response does not contain a 'cfgState' object!");
                        }
                    } else {
                        self.setState({
                            cfgState: null,
                            progressState: false,
                            error: Object.assign({}, {
                                messageType: null
                            }, result.error)
                        });
                    }
                }

                switch(method) {
                    case "copySubCfgObject":
                    case "deleteSubCfgObject":
                    case "setCfgValue":
                    case "handleInstance":
                        self.props.hcs.partsList.refresh();
                        hcs.api.updateHeartbeat();
                        break; 
                }

                window.cadclick.debug.showConfigHistory(self.subConfigHistory.debug);

                if(result.success === true) {
                    hcs.api.ecsTrigger(method, ecsObject, optionalTriggerData);
                }

                self.callbackRunning = null;
            }).catch(function(error) {
                loading = false;
                hcs.api.progressBar.progress(false);

                console.error(error);

                self.setState({
                    error: {
                        message: error.message,
                        url: ecsUrl,
                        fileName: error.fileName,
                        lineNumber: error.lineNumber,
                        stack: error.stack,
                        columnNumber: error.columnNumber,
                        messageType: "jsError"
                    },
                    progressState: false,
                });

                self.callbackRunning = null;
            });
    }

    /**
     * Original configuration state has all attributes at the same level.
     * like in this structure:
     *
     *      - attribute 1 (group 1)
     *      - attribute 2 (group 1)
     *      - attribute 3 (group 2)
     *      - attribute 4 (group 2)
     *
     * For react rendering the following structure is much easier to handle.
     * This function transforms all attributes to a tree-like structure where each group has its own node:
     *
     * - group 1
     *      - attribute 1
     *      - attribute 2
     * - group 2
     *      - attribute 3
     *      - attribute 4
     * @param {Object} cfgState - Original configuration state from ECS.
     * @returns {Object} - Transformed configuration object.
     */
    buildConfigurationData(cfgState) {
        const { hcs } = this.props;

        let configGroupList = {
            configLocks: null,
            items: []
        };

        let oldGroupId = null;

        // Add "Welcome" section when enabled in database settings.
        if(hcs.settings.get("SETTINGS.SHOW_WELCOME_SECTION", "bool")) {
            configGroupList.items.push({
                groupId: "GRP_WELCOME_SCREEN",
                groupTrans: hcs.t.ecs("GRP_WELCOME_SCREEN"),
                finished: true,
                checkFinished: true,
                lastActive: false,
                isStartItem: false,
                inProgress: false,
                attributes: []
            });
        }

        cfgState.cfgobj.attributes.forEach((item, index) => {
            let groupId = item.data.AGROUP;

            if(groupId !== oldGroupId) {
                configGroupList.items.push({
                    groupId: groupId,
                    groupTrans: this.props.hcs.t.ecs(groupId),
                    finished: true,
                    checkFinished: true,
                    lastActive: false,
                    isStartItem: index === 0,
                    inProgress: false,
                    attributes: []
                });
            }

            configGroupList.items[configGroupList.items.length - 1].attributes.push(item);

            oldGroupId = groupId;
        }, this);

        let lastGroup = null;

        // evaluate if group is finished -> all required attributes are set
        configGroupList.items.forEach(group => {
            // Exclude "navigation" attributes (Button "Next", "Back", ...)
            group.finished = this.checkAttributesFinished(group.attributes.filter(attr =>
                attr.data.CFG_CONTROL !== "CTRL_NAVI"
            ));
            group.checkFinished = this.checkAttributesFinished(group.attributes, true);

            if(!group.finished && (lastGroup === null || lastGroup.finished)) {
                group.lastActive = this.visitedGroups(false).includes(group.groupId);
            }
            group.inProgress = !group.checkFinished && (lastGroup === null || lastGroup.checkFinished);

            lastGroup = group;
        }, this);

        // Remove groups with all attributes invisible
        // or groups using wizard where wizard is disabled.
        configGroupList.items = configGroupList.items.filter(item => {
            return item.attributes.filter(a => a.data.CFG_CONTROL !== "WIZARD" || a.info.visible).length > 0;
        });

        return hcs.cfgEngine.modifyEcsConfigurationData(configGroupList);
    }

    /**
     * Return current configuration data object with additional properties:
     *   - items: List of all CFG group items
     *   - lastFinished: Group item with latest "finished" state.
     *   - lastActive: Group item which was "last active".
     */
    get configurationData() {
        const cfgData = this.state.configurationData;

        let searchFunc = (propertyName) => {
            for(let i = cfgData.items.length - 1; i >= 0; i--) {
                if(cfgData.items[i][propertyName]) {
                    return cfgData.items[i];
                }
            }

            return null;
        };

        return {
            items: cfgData.items,
            lastFinished: searchFunc("finished"),
            lastActive: searchFunc("lastActive")
        };
    }

    /**
     * Check attribute list for "finished" state.
     * A group (of attributes) is finished when all attributes with state "required" has the "assigned" state.
     * In case there are no "required" attributes the state can also be set to "finished".
     * @param {Object[]} attributes - List of attributes to be checked
     * @param {bool} [includeAttributeEnabled=false] - When "true" include the attribute's "enabled" state.
     * @returns {boolean} Returns true when attribute list can be set to "finished".
     */
    checkAttributesFinished(attributes, includeAttributeEnabled = false) {
        let finished = true;
        // Group must at least contain one visible attribute.
        let groupVisible = attributes.filter(attribute => attribute.info.visible).length > 0;

        attributes.filter(attribute => (attribute.info.visible || (includeAttributeEnabled && attribute.info.enabled)) && attribute.info.required).forEach(function(attribute) {
            switch(attribute.info.type) {
                case "objlist":
                    // When attribute is a subconfiguration we must evaluate all child attributes.
                    if(attribute.cfgobjs && attribute.cfgobjs.find(cfg => !cfg.info.complete)) {
                        // child attributes complete == true
                        finished = false;
                    }
                    break;

                default:
                    if(!attribute.info.assigned) {
                        finished = false;
                    }
                    break;
            }
        }, this);

        return finished && groupVisible;
    }

    /**
     * This function will be bubbled up to each single control component.
     * The control has to ensure that this function will be called before sending any changes to ECS.
     * 
     * This function checks if the user wants to change a value in an
     * already finished step. This requires an ECS reset for all following steps.
     * In this case a warning dialog appears where the user has to confirm the ECS reset.
     * When the user didn't confirm this the control itself (which calls the "checkValueChange" function)
     * has to ensure that the old input value 
     * @param {object} control - Instance of single react control.
     * @param {object} options - Options
     * @param {function} options.confirmed - Event function being called when the user has confirmed to ECS reset.
     * @param {function} options.rejected - Event function being clled when the user denied the ECS reset.
     */
    checkValueChange(control, options) {
        let self = this;

        const { hcs } = this.props;

        let opts = Object.assign({}, {
            confirmed: function() { },
            rejected: function() { }
        }, options);

        // Reset configuration which loads the last CFG state where
        // the value of the trigger control has being changed.
        let cfgReset = function() {
            // ToDo: Make an ECS reset first.
            let attrId = control.props.data.ident;

            self.configure("resetConfiguration", attrId, null, {
                groupId: control.props.data.data.AGROUP,
                success: (result) => {
                    if(result.success === true) {
                        opts.confirmed.call(self);
                    }
                }
            });
        };

        /*
         * IMPORTANT: Allow continuing configuration after an error has occured.
        if(!this.state.cfgState) {
            opts.confirmed.call(self);
            return;
        }*/

        // Group ID of given control
        let group = this.state.cfgState.cfgobj.attributes.find(a => {
            switch(a.info.type) {
                case "objlist":
                    switch(a.data.CFG_CONTROL) {
                        case "HIDDEN":
                        case "DEFAULT":
                            return a.ident === control.props.data.ident;

                        default:
                            // In case of (inline) subconfiguration we must search into all subobjects for attributes.
                            return a.cfgobjs.map(c => c.attributes).flat(1).find(a => a.ident === control.props.data.ident);
                    }

                default:
                    return a.ident === control.props.data.ident;
            }
        });

        let groupId = group.data.AGROUP;
        // Group index of given control.
        let groupIndex = this.state.configurationData.items.findIndex(g => g.groupId === groupId);
        let groupNext = this.state.configurationData.items[groupIndex + 1];

        if(groupNext && groupNext.finished) {
            if(hcs.settings.get("SETTINGS.CONFIGURATION_RESET_ENABLED", "bool")) {
                if(hcs.settings.get("SETTINGS.CONFIGURATION_RESET_MESSAGE_ENABLED", "bool") && !hcs.api.session("CONFIGURATION_HIDE_RESET_MESSAGE")) {
                    let checkboxId = hcs.api.createUniqueId("hcs-ck-hide-config-reset");

                    let messageText = hcs.t.gui("ConfigReset_Message") +
                        `<div class="hcs-ck-hide-config-reset"><input id="${checkboxId}" type="checkbox" /><label for="${checkboxId}">${hcs.t.gui("ConfigReset_HideMessage")}</label></div>`;

                    hcs.api.messageBox.show({
                        modal: true,
                        text: messageText,
                        classNames: "hcs-config-reset-message",
                        buttons: MessageBox.MB_OK | MessageBox.MB_CANCEL,
                        messageType: MessageBox.MB_QUESTION,
                        buttonTexts: {
                            "ok": hcs.t.gui("ConfigReset_ButtonEdit")
                        },
                        onOk: function() {
                            let checkboxChecked = document.getElementById(checkboxId).checked;

                            hcs.api.session("CONFIGURATION_HIDE_RESET_MESSAGE", checkboxChecked);

                            cfgReset.call(self);
                            this.close();
                        },
                        onCancel: function() {
                            opts.rejected.call(self);
                            this.close();
                        }
                    });
                } else {
                    cfgReset.call(self);
                }
            } else {
                opts.confirmed.call(self);
            }
        } else {
            opts.confirmed.call(self);
        }
    }

    /**
     * Check if current configuration is locked because all fields have
     * been entered correctly and a value change in this group may reset
     * the entire configuration.
     * @param {string} groupId - ID of the CFG group to be checked.
     * @returns {boolean} true when desired group is "locked".
     */
    checkConfigLocked(groupId) {
        const { configurationData } = this.state;

        if(!configurationData.configLocks) {
            return false;
        }

        let visitedGroups = this.visitedGroups();

        return configurationData.configLocks.filter((item) => {
            return item.lock.includes(groupId) && visitedGroups.includes(item.groupPassed);
        }).length > 0;
    }

    /**
     * Returns a list of all config groups which have already been visited or finished.
     * @param {boolean} [includeCurrent=true] - The default list includes finished groups and
     * the next group in line. Set to false to only return finished groups.
     * @returns {array} List of visited (and finished) config groups.
     */
    visitedGroups(includeCurrent = true) {
        const { hcs } = this.props;
        const { configurationData } = this.state;
        // When adding current group we must add 1 because the first group contains the "Welcome" button.
        let welcomeIndex = hcs.settings.get("SETTINGS.SHOW_WELCOME_SECTION", "bool") ? 1 : 0;
        let groups = [];

        if(configurationData) {
            groups = configurationData.items ? configurationData.items.filter(i => { return i.finished; }).map(i => { return i.groupId; }) : [];

            if(includeCurrent && configurationData.items[groups.length + welcomeIndex]) {
                groups.push(configurationData.items[groups.length + welcomeIndex].groupId);
            }
        }

        return groups;
    }

    getTooltipContent(dataTipUid) {
        if(dataTipUid) {
            let tipElement = document.querySelector(`a[data-tip='${dataTipUid}'`);

            if(tipElement) {
                return tipElement.nextSibling.innerHTML;
            }
        }
    }

    render() {
        const { hcs } = this.props;
        const {
            error,
            configurationData,
            cfgState,
            currentGroup,
            progressState,
            isSubConfig,
            subConfigMode,
            configUiHidden
        } = this.state;

        if(configurationData !== null) {
            let wrapperClasses = ["hcs-wrapper"];

            if(!this.state.configVisible) {
                wrapperClasses.push("hcs-hidden");
            } else {
                wrapperClasses.push("hcs-visible");
            }

            let configurationDataNav = this.state.configurationData;

            let navClasses = ["hcs-nav"];

            switch(subConfigMode) {
                case ConfigurationModes.SubConfigurationTopMenu:
                    configurationDataNav = this.state.configurationDataTopLevel;
                    navClasses.push("hcs-locked");
                    break;
            }

            const groupIndex = configurationData.items
                .map((group, index) => group.groupId === currentGroup ? index : -1)
                .find(index => index > -1);

            hcs.api.instance().setAttribute("config-mode", subConfigMode.domAttr);

            return configUiHidden ? null : (
                <>
                    <div className={navClasses.join(" ")}>
                        <div className="hcs-scroll-top">
                            <svg icon-id="icn-001-2-arrow-bold" version="2.0">
                                <use href="#icn-001-2-arrow-bold"></use>
                            </svg>
                        </div>
                        <ul>
                            { this.subConfigHistory.last && this.subConfigHistory.last.subConfigMode == ConfigurationModes.SubConfigurationComplex?
                                <li className="hcs-nav-subconfig-exit">
                                    <a onClick={_ => { this.configure("exitCurrentCfgObject", null, null, { accept: false }); }}>
                                        <svg icon-id="icn-001-2-arrow" version="2.0">
                                            <use href="#icn-001-2-arrow"></use>
                                        </svg>
                                        <div>
                                            <h4>{cfgState.cfgobj.data.PARENT_CFG_NAME}</h4>
                                            <h5>{cfgState.cfgobj.flags ? cfgState.cfgobj.flags.cfgName : ""}</h5>
                                        </div>
                                    </a>
                                </li> : null
                            }
                            {configurationDataNav.items
                                .filter(item => item.groupId !== "GRP_WELCOME_SCREEN" || subConfigMode === ConfigurationModes.Default)
                                .map((groupItem, index) => {
                                    switch(groupItem.groupId) {
                                        case "GRP_WELCOME_SCREEN":
                                            return (
                                                <HcsNavBarItemWelcome
                                                    key={`hcs-nav-${index}`}
                                                    data={groupItem}
                                                    groupIndex={index + 1}
                                                    hcs={this.props.hcs}
                                                    subConfigMode={subConfigMode}
                                                    currentGroup={currentGroup}
                                                    onGroupChanged={this.changeGroup}
                                                    iconMapping={this.navBarIconMapping}
                                                    navClicked={this.navClicked}
                                                    configWait={this.configWait}
                                                    configLocked={this.checkConfigLocked(groupItem.groupId)}
                                                    progressState={progressState}
                                                />);

                                        default:
                                            return (
                                                <HcsNavBarItem
                                                    key={`hcs-nav-${index}`}
                                                    data={groupItem}
                                                    groupIndex={index + 1}
                                                    hcs={this.props.hcs}
                                                    subConfigMode={subConfigMode}
                                                    currentGroup={currentGroup}
                                                    onGroupChanged={this.changeGroup}
                                                    iconMapping={this.navBarIconMapping}
                                                    navClicked={this.navClicked}
                                                    configWait={this.configWait}
                                                    configLocked={this.checkConfigLocked(groupItem.groupId)}
                                                    progressState={progressState}
                                                />
                                            );
                                    }
                                }
                            )}
                        </ul>
                        <div className="hcs-scroll-bottom">
                            <svg icon-id="icn-001-2-arrow-bold" version="2.0">
                                <use href="#icn-001-2-arrow-bold"></use>
                            </svg>
                        </div>
                    </div>
                    <div className={wrapperClasses.join(" ")} group-index={groupIndex} group-id={currentGroup}>
                        <HcSInlineError error={error} />

                        {configurationData.items
                            .filter(item => item.groupId !== "GRP_WELCOME_SCREEN" || subConfigMode === ConfigurationModes.Default)
                            .map((groupItem, index) => {
                                return (
                                    <HcsGroup
                                        key={`hcs-group-${index}`}
                                        data={groupItem}
                                        groupIndex={index + 1}
                                        subConfigInfo={{
                                            isSubConfig: isSubConfig,
                                            subConfigMode: subConfigMode,
                                            subConfigName: this.state.subConfigName,
                                            subConfigDescription: this.state.subConfigDescription
                                        }}
                                        hcs={this.props.hcs}
                                        currentGroup={currentGroup}
                                        onConfig={this.configure}
                                        onGroupChanged={this.changeGroup}
                                        configWait={this.configWait}
                                        configLocked={this.checkConfigLocked(groupItem.groupId)}
                                        checkValueChange={this.checkValueChange}
                                        progressState={progressState}
                                    />);
                            }
                        )}

                        { /* Render tooltips for "hcs-info-button" controls. */ }
                        <ReactTooltip
                            className="hcs-tooltip"
                            effect="solid"
                            globalEventOff="click"
                            getContent={(dataTipUid) => { return this.getTooltipContent(dataTipUid); } }
                            html
                        />
                    </div>
                    <HcsVersionInfo hcs={this.props.hcs} />
                    <HcsPointAndClickHelper
                        hcs={this.props.hcs}
                        visible={this.state.showPointAndClick}
                        ref={ref => this.pointAndClickHelper = ref} />
                </>
            );
        }

        return null;
    }
}
